import axios from 'axios';
import { AdresseIP } from './AdresseIp';

export class CategorieChambreService {

    constructor(){
        this.adresse = new AdresseIP()
    }
    
    getAll() {
        
        return axios.get(this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/categorie-chambre')
                    .then(res => res.data);
    }
    create(newCategorie) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/categorie-chambre'
        return axios.post(url,newCategorie)
                    .then(res => res.data);
    }
    update(idCategorie ,newCategorie) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/categorie-chambre/'
        return axios.put(url+idCategorie, newCategorie)
                    .then(res => res.data);
    }
    delete(idCategorie) {
        const url = this.adresse.getAdresseIP()+'/service/api/hebergement-cenou/campus-faso/categorie-chambre/'
        return axios.patch(url+idCategorie)
                    .then(res => res.data)
    }
    

}